import { render } from "./ConsentRequired.vue?vue&type=template&id=bcdca9c8&scoped=true"
import script from "./ConsentRequired.vue?vue&type=script&lang=js"
export * from "./ConsentRequired.vue?vue&type=script&lang=js"

import "./ConsentRequired.vue?vue&type=style&index=0&id=bcdca9c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcdca9c8"]])

export default __exports__